import React, { createContext, useContext, useState, useEffect } from 'react';

const SessionContext = createContext();

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession debe usarse dentro de SessionProvider');
  }
  return context;
};

export const SessionProvider = ({ children }) => {
  const [session, setSession] = useState(() => {
    try {
      const saved = sessionStorage.getItem('digitalMenuSession');
      return saved ? JSON.parse(saved) : null;
    } catch (error) {
      return null;
    }
  });

  // Process OAuth authToken from URL hash fragment
  useEffect(() => {
    const hash = window.location.hash;
    if (!hash.includes('authToken=')) return;

    const token = hash.split('authToken=')[1]?.split('&')[0];
    if (!token) return;

    try {
      // Decode JWT payload (base64url)
      const parts = token.split('.');
      if (parts.length === 3) {
        const payload = JSON.parse(atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')));
        setSession((prev) => ({
          ...prev,
          customer: {
            customerId: `${payload.provider}_${payload.providerId}`,
            name: payload.name || '',
            email: payload.email || '',
            avatar: payload.avatar || '',
            provider: payload.provider,
            isGuest: false,
          },
          isAuthenticated: true,
        }));
      }
    } catch (err) {
      // Silently fail on invalid auth tokens
    }

    // Clean hash from URL
    window.history.replaceState(null, '', window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    try {
      if (session) {
        sessionStorage.setItem('digitalMenuSession', JSON.stringify(session));
      } else {
        sessionStorage.removeItem('digitalMenuSession');
      }
    } catch (error) {
      // Silently fail on storage errors
    }
  }, [session]);

  const startSession = (sessionData) => {
    setSession(sessionData);
  };

  const endSession = () => {
    sessionStorage.removeItem('digitalMenuSession');
    setSession(null);
  };

  const updateSession = (updates) => {
    setSession(prev => ({ ...prev, ...updates }));
  };

  return (
    <SessionContext.Provider
      value={{
        session,
        startSession,
        endSession,
        updateSession
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};
